import { useEffect, useState } from "react";
import ContentAsync from "../../parts/ContentAsync";
import Api from "../../Api";
import { useNavigate, useParams } from "react-router-dom";
import ClientBar from "../../parts/ClientBar";
import Section from "../../parts/Section";
import { MoneyBlock, TextAreaBlock } from "../../parts/FormBlocks";
import { brlToInt } from "../../utils";
import { Client, Receipt, ReceiptUI, UIValue } from "../../types";

const FinanceReceiptsCreate = () => {
  const { clientUuid } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [client, setClient] = useState<Client | null>(null);
  const [receipt, setReceipt] = useState<ReceiptUI>({
    uuid: "",
    externalHash: "",
    canceled: false,
    amount: "",
    reference: "",
    date: new Date(),
    sends: [],
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    Api.financeReceiptsClient(clientUuid!).then(({ client }) => [
      setClient(client),
      setLoading(false),
    ]);
  }, [clientUuid]);

  const change = (key: keyof Receipt) => (value: UIValue) => {
    setReceipt((receipt) => ({ ...receipt, [key]: value }));
  };

  const submit = async (event: React.FormEvent) => {
    setError(false);
    setSaving(true);
    event.preventDefault();

    const payload: Receipt = {
      ...receipt,
      amount: brlToInt(receipt.amount),
    };

    const result = await Api.financeCreateReceipt(client!.uuid, payload);
    result.success
      ? navigate(`/financeiro/recibos/cliente/${client!.uuid}`)
      : setError(true);
    setSaving(false);
  };

  return (
    <ContentAsync loading={loading}>
      {client && (
        <div>
          <ClientBar
            action="Adicionando recibo para"
            client={client.name}
            url={`/financeiro/recibos/cliente/${client.uuid}`}
          />

          <Section>
            <form className="p-4 flex flex-col gap-4" onSubmit={submit}>
              <MoneyBlock
                label="Valor"
                value={receipt.amount}
                onChange={change("amount")}
                autoFocus={true}
              />

              <TextAreaBlock
                label={"Referência"}
                value={receipt.reference}
                onChange={change("reference")}
              />

              <hr />

              {error && (
                <div className="text-sm text-red-700 font-bold text-right">
                  Erro ao criar recibo
                </div>
              )}

              <div className="text-right">
                <button
                  className="rounded py-2 px-4 bg-sky-600 hover:bg-sky-500 font-extrabold text-white"
                  disabled={saving}
                >
                  Criar
                </button>
              </div>
            </form>
          </Section>
        </div>
      )}
    </ContentAsync>
  );
};

export default FinanceReceiptsCreate;
